<template>
    <div id="packer">
        <transition name="slide-fade" mode="out-in" appear>
            <router-view>
            </router-view>
        </transition>
    </div>
</template>

<script>
export default {
    props: {
    },
    data: function () {
        return {
        }
    },
    created: function() {
        
    },
    mounted: function() {
        
    },
    watch: {
    },
    methods: {
    },
    components: {
    },
    computed: {

    }
}
</script>

<style scoped>

</style>
